import React, { useEffect, useState } from 'react';
import { BaseResponseProps } from '@qlibs/react-components';
import { httpRequest } from '../../../helpers/api';
import { AppConfigProperties } from '../types/appConfig.type';
import 'react-quill/dist/quill.snow.css';

const PrivacyPolicyPublic = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<AppConfigProperties>({
    configId: '',
    key: '',
    value: '',
  });

  useEffect(() => {
    const init = async () => {
      try {
        setIsLoading(true);

        const res = await httpRequest.get<
          BaseResponseProps<AppConfigProperties>
        >('/app-configs-public/privacy_policy');
        if (res && res.data.payload) {
          setData(res.data.payload);
        }
      } catch (error) {
        console.error('failed get privacy policy', error);
      } finally {
        setIsLoading(false);
      }
    };

    init();
  }, []);

  return (
    <React.Fragment>
      {isLoading ? <div>Loading</div> : false}
      <div dangerouslySetInnerHTML={{ __html: data.value }}></div>
    </React.Fragment>
  );
};

export default PrivacyPolicyPublic;
